import type { Configuration, Language, Translate } from '../types';

import { headerLoggedIn } from './header-logged-in';
import { headerLoggedOut } from './header-logged-out';
import { settingsDropdown } from './settings-dropdown';

export const v1: Configuration = (t: Translate, lang: Language) => ({
  navigation: {
    headerLoggedIn: headerLoggedIn(t, lang),
    headerLoggedOut: headerLoggedOut(t, lang),
    settingsDropdown: settingsDropdown(t, lang),
  },
  experiments: [],
});
